import { generateUUID } from "@/helpers/uuid";
import { Moment } from "moment";

export class ReceiveWarehouseTransferFormStateLine {
  rowId: string = generateUUID();

  id: string | null = null;
  rackFromName: string | undefined = undefined;
  rackFromId: string | undefined = undefined;
  rackToName: string | undefined = undefined;
  rackToId: string | undefined = undefined;
  notes: string | undefined = undefined;
  part: string | undefined = undefined;
  partId: string | undefined = undefined;
  serialNumber: string | undefined = undefined;
  totalQty = 0;
  uom: string | undefined = undefined;
  uomId: string | undefined = undefined;
  qtyReceive = 0;
  qtyOutstanding = 0;
}

export class ReceiveWarehouseTransferFormState {
  receivedDate: Moment | null = null;
  note = "";
  receiveWarehouseTransferLines: ReceiveWarehouseTransferFormStateLine[] = [];
}
